if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          } else if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && this.classList.contains('hidden')) {
            // HFS a11y (COL-28): the button hides itself (e.g. product volume pricing), so focus would fall to
            // <body>; move it to the first revealed item instead.
            if (!nextElementToFocus.hasAttribute('tabindex')) nextElementToFocus.setAttribute('tabindex', '-1');
            nextElementToFocus.focus();
          }
        });
      }
      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        const toggle = this.querySelector('button');
        if (toggle) toggle.setAttribute('aria-expanded', toggle.getAttribute('aria-expanded') !== 'true');
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}
